export default function StatsCard({ icon: Icon, label, value, sub, color = '#000666', tint, trend }) {
  return (
    <div
      className="hg-card p-5 flex items-start gap-4 transition-all hover:-translate-y-1"
      style={{ cursor: 'default' }}
    >
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
        style={{ background: tint || `${color}15`, color }}
      >
        <Icon size={24} />
      </div>
      <div className="flex-1 min-w-0">
        <div
          className="text-2xl font-black leading-none mb-1"
          style={{ color, fontFamily: 'Cairo, sans-serif' }}
        >
          {value ?? '—'}
        </div>
        <div
          className="text-sm font-bold text-dim truncate"
          style={{ fontFamily: 'Tajawal, sans-serif' }}
        >
          {label}
        </div>
        {sub && (
          <div className="text-xs text-ghost mt-1" style={{ fontFamily: 'Tajawal, sans-serif' }}>
            {sub}
          </div>
        )}
      </div>
      {trend !== undefined && (
        <div
          className="text-xs font-bold px-2 py-1 rounded-lg flex-shrink-0"
          style={{
            background: trend >= 0 ? 'rgba(27,109,36,0.08)' : 'rgba(186,26,26,0.08)',
            color: trend >= 0 ? '#1B6D24' : '#BA1A1A',
          }}
        >
          {trend >= 0 ? '+' : ''}{trend}%
        </div>
      )}
    </div>
  )
}
